var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07808 4.99972L9.00776 1.50753C9.05687 1.4495 9.01558 1.36133 8.93968 1.36133H8.04906C7.9966 1.36133 7.94638 1.38477 7.91178 1.42494L5.49549 4.30552L3.07919 1.42494C3.04571 1.38477 2.99549 1.36133 2.94191 1.36133H2.05129C1.9754 1.36133 1.9341 1.4495 1.98321 1.50753L4.9129 4.99972L1.98321 8.49191C1.97221 8.50485 1.96515 8.52067 1.96287 8.53749C1.9606 8.55432 1.9632 8.57145 1.97037 8.58684C1.97753 8.60224 1.98897 8.61525 2.00331 8.62434C2.01766 8.63343 2.03431 8.63821 2.05129 8.63811H2.94191C2.99437 8.63811 3.04459 8.61468 3.07919 8.5745L5.49549 5.69392L7.91178 8.5745C7.94526 8.61468 7.99549 8.63811 8.04906 8.63811H8.93968C9.01558 8.63811 9.05687 8.54995 9.00776 8.49191L6.07808 4.99972Z",
    fill: "#1890FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.57b77f8dc7dd68ebfd073435b9ea306d.svg";
export { ForwardRef as ReactComponent };